import React, { useEffect, useState } from 'react';
import './WorkplacesTab.css';
import UniversalTable from '../UniversalTable/UniversalTable';
import { createPortal } from 'react-dom';
import CreateWorkplace from '../CreateWorkplace/CreateWorkplace';
import ButtonRolesAction from '../ButtonRolesAction/ButtonRolesAction';
import ContextMenu from '../ContextMenu/ContextMenu';
import {
  deleteWorkplace,
  getWorkplaceUsers,
  sendUpdateWorkplace,
} from '../../api/workplaceApi';
import InviteEmployee from '../InviteEmployee/InviteEmployee';
import StaffTabWorkplace from '../StaffTabWorkplace/StaffTabWorkplace';
import { formatDate } from '../../utils/formatDate';
import { addUserToWorkplace } from '../../api/staffApi';
import NotificationPopup from '../NotificationPopup/NotificationPopup';
const WorkplacesTab = ({
  dataList,
  selectedItems,
  selectedItemId,
  expandedRow,
  updateDepartmentData,
  selectedTab,
  onSelectItem,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [menuTarget, setMenuTarget] = useState(null);
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [loginInvitedUser, setLoginInvitedUser] = useState('');
  // Состояния для CreateWorkplace
  const [isCreateWorkplaceMounted, setIsCreateWorkplaceMounted] =
    useState(false);
  const [isCreateWorkplaceVisible, setIsCreateWorkplaceVisible] =
    useState(false);
  // Состояния для InviteEmployee
  const [isPopupMounted, setIsPopupMounted] = useState(false);
  const [isVisiblePopupInvite, setIsVisiblePopupInvite] = useState(false);

  const [data, setData] = useState(dataList || []);
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState('');
  const [targetWorkplace, setTargetWorkplace] = useState('');
  const [targetRow, setTargetRow] = useState('');
  const [deleteError, setDeleteError] = useState();

  // При открытии всплывашки приглашения открываем ее и добавляем workplaces_id
  const handleOpenInviteMolal = (item) => {
    setTargetWorkplace(item.id);
    setIsPopupMounted(true);
  };

  const columns = [
    { key: 'number', title: '№' },
    { key: 'name', title: 'Наименование' },
    { key: 'role_name', title: 'Доступ' },

    {
      key: 'worker',
      title: 'Сотрудник',
      type: 'workerBlok',

      button: {
        title: 'Пригласить',
        onClick: handleOpenInviteMolal,
      },
    },
    {
      key: 'status',
      title: 'Статус',
      type: 'select',
      options: [
        { value: 'active', label: 'Активен' },
        { value: 'archived', label: 'В архиве' },
      ],
      onChange: (options, workplaceId) => {
        sendUpdateWorkplace({
          organisation_id: selectedItemId,
          status_id: options.value === 'archived' ? 2 : 1,
          id: workplaceId,
        });
        console.log(options);
      },
    },
    { key: 'price', title: 'Цена', type: 'text' },
    {
      key: 'integrate_to_production',
      title: 'Интеграция',
      type: 'workerBlok',

      button: {
        title: 'Интегрировать в производство',
        onClick: handleOpenInviteMolal,
      },
    },
  ];

  const handleContextMenu = (e, item) => {
    e.preventDefault();
    setMenuTarget(item);
    setShowMenu(true);
    setMenuPosition({ top: e.clientY, left: e.clientX });
    setDeleteError('');
  };

  const handleSelectedPopup = (name) => { };

  const handleEdit = () => {
    handleSelectedPopup(selectedTab);

    setShowMenu(false);
  };

  const handleDuplicate = () => {
    console.log('Дублировать');

    handleSelectedPopup(selectedTab);
    setShowMenu(false);
  };

  const handleArchive = () => {
    console.log('В архив');
    setShowMenu(false);
  };

  const handleDelete = () => {
    console.log('Удалить');
    setShowMenu(false);

    if (!menuTarget) return;

    deleteWorkplace({ id: menuTarget.id, organisation_id: selectedItemId })
      .then(() => {
        // Удаляем элемент из локального состояния
        const newData = data.filter((item) => item.id !== menuTarget.id);
        setData(newData);

        // Обновляем данные в родительском компоненте

        // Сбрасываем menuTarget
        setMenuTarget(null);
      })
      .catch((err) => {
        console.error('Ошибка при удалении:', err);
        if (err.data.message === 'There are employees') {
          setDeleteError('Нельзя удалить рабочие место с сотрудниками');
        }
      });
  };

  const handleCloseMenu = () => {
    setShowMenu(false);
  };

  // Обновляем data при изменении dataList
  useEffect(() => {
    setData((prevData) =>
      dataList.map((item, i) => {
        const existing = prevData.find((p) => p.id === item.id);
        return existing
          ? { ...item, number: i + 1, children: existing.children || null }
          : item;
      })
    );
  }, [dataList]);

  // Отправка приглашения
  const handleInviteSubmit = async (login, workplace_id = null) => {
    console.log('общая функция для приглашения', login);
    const trimmedLogin = login.trim();
    setLoginInvitedUser(trimmedLogin);
    setIsLoading(true);
    try {
      await addUserToWorkplace({
        workplace_ids: workplace_id ? [workplace_id] : [targetWorkplace],
        organisation_id: selectedItemId,
        login: trimmedLogin,
      });

      const res = await getWorkplaceUsers({
        workplace_id: workplace_id ? workplace_id : targetWorkplace,
        organisation_id: selectedItemId,
      });

      const listData = res.data.map((item, index) => ({
        ...item,
        number: index + 1,
        invited_at: formatDate(item.invited_at),
        deleted_at: formatDate(item.deleted_at),
      }));
      setIsNotificationVisible(true);
      // Обновляем только один элемент списка, не сбрасывая весь data

      setData((prevData) =>
        prevData.map((item) =>
          item.id === (workplace_id ? workplace_id : targetWorkplace)
            ? {
              ...item,
              users: listData, // Обновляем только пользователей
              children:
                targetRow === item.id ? (
                  <StaffTabWorkplace
                    handleInviteSubmit={handleInviteSubmit}
                    dataList={listData}
                    handleContextMenu={handleContextMenu}
                    selectedItems={selectedItems}
                    selectedItemId={selectedItemId}
                    expandedRow={targetRow}
                    updateDepartmentData={updateDepartmentData}
                    selectedTab={selectedTab}
                    onSelectItem={onSelectItem}
                    targetWorkplace={targetWorkplace}
                    handleOpenInviteMolal={handleOpenInviteMolal}
                  />
                ) : null,
            }
            : item
        )
      );

      handleClosePopup();
    } catch (err) {
      if (
        err.data?.message === 'Organisation id is not valid or user not found'
      ) {
        setError('Пользователь с таком логином не найден');
      } else if (
        err.data?.message === 'The employee has already been invited'
      ) {
        setError('Сотрудник уже был приглашен');
      } else {
        setError('Ошибка отправки приглашения');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleClosePopup = () => {
    setIsVisiblePopupInvite(false);
    setError('');
  };
  // Управляем плавным появлением и исчезновением
  useEffect(() => {
    if (isPopupMounted) {
      const timer = setTimeout(() => setIsVisiblePopupInvite(true), 100); // Ждем, пока попап добавится в DOM
      return () => clearTimeout(timer);
    }
  }, [isPopupMounted]);

  // После завершения анимации удаления убираем попап из DOM
  useEffect(() => {
    if (!isVisiblePopupInvite) {
      const timer = setTimeout(() => setIsPopupMounted(false), 300); // Ждем анимацию
      return () => clearTimeout(timer);
    }
  }, [isVisiblePopupInvite]);

  const handleRowClick = async (itemid) => {
    setDeleteError('');
    // Проверка, если текущая строка уже открыта, очищаем её
    if (targetRow === itemid) {
      setTargetRow(null); // Закрыть строку
      setData((prevData) =>
        prevData.map(
          (item) => (item.id === itemid ? { ...item, children: null } : item) // Очищаем children
        )
      );
      return;
    }

    setTargetRow(itemid); // Открываем строку

    try {
      const res = await getWorkplaceUsers({
        workplace_id: itemid,
        organisation_id: selectedItemId,
      });

      const listData = res.data.map((item, index) => ({
        ...item,
        number: index + 1,
        invited_at: formatDate(item.invited_at),
        deleted_at: formatDate(item.deleted_at),
      }));

      // Обновляем данные с новым вложенным компонентом
      setData((prevData) =>
        prevData.map((item) =>
          item.id === itemid
            ? {
              ...item,
              children: (
                <StaffTabWorkplace
                  handleInviteSubmit={handleInviteSubmit}
                  dataList={listData || []}
                  selectedItems={selectedItems}
                  selectedItemId={selectedItemId}
                  expandedRow={itemid}
                  updateDepartmentData={updateDepartmentData}
                  selectedTab={selectedTab}
                  onSelectItem={onSelectItem}
                  targetWorkplace={targetWorkplace}
                  handleOpenInviteMolal={handleOpenInviteMolal}
                />
              ),
            }
            : item
        )
      );
    } catch (err) {
      console.error('Ошибка загрузки сотрудников:', err);
    }
  };

  useEffect(() => {
    setData((prevData) => {
      return prevData.map((item) =>
        item.id === targetRow
          ? {
            ...item,
            children: (
              <StaffTabWorkplace
                handleInviteSubmit={handleInviteSubmit}
                dataList={item.children ? item.children.props.dataList : []}
                selectedItems={selectedItems}
                selectedItemId={selectedItemId}
                expandedRow={targetRow}
                updateDepartmentData={updateDepartmentData}
                selectedTab={selectedTab}
                onSelectItem={onSelectItem}
                targetWorkplace={targetWorkplace}
                handleOpenInviteMolal={handleOpenInviteMolal}
              />
            ),
          }
          : item
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  // Обработчик открытия формы создания рабочего места
  const handleOpenCreateWorkplace = () => {
    setIsCreateWorkplaceMounted(true);
  };

  // Обработчик закрытия формы создания рабочего места
  const handleCloseCreateWorkplace = () => {
    setIsCreateWorkplaceVisible(false);
  };

  // Анимация появления CreateWorkplace
  useEffect(() => {
    if (isCreateWorkplaceMounted) {
      const timer = setTimeout(() => setIsCreateWorkplaceVisible(true), 100);
      return () => clearTimeout(timer);
    }
  }, [isCreateWorkplaceMounted]);

  // Анимация исчезновения и удаление из DOM CreateWorkplace
  useEffect(() => {
    if (!isCreateWorkplaceVisible) {
      const timer = setTimeout(() => setIsCreateWorkplaceMounted(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isCreateWorkplaceVisible]);

  useEffect(() => {
    if (isNotificationVisible) {
      const timer = setTimeout(() => {
        setIsNotificationVisible(false);
        setLoginInvitedUser('');
      }, 4000);

      return () => clearTimeout(timer); // Очищаем таймер при размонтировании
    }
  }, [isNotificationVisible]);

  return (
    <div className='workplaces-tab'>
      <div className='workplaces-tab__header'>
        <h3 className='workplaces-tab__title'>Рабочие места</h3>
      </div>

      {data?.length > 0 ? (
        <UniversalTable
          data={data}
          columns={columns}
          handleContextMenu={handleContextMenu}
          selectedItems={selectedItems}
          onRowClick={handleRowClick}
          onSelectItem={onSelectItem}
          expandedRow={targetRow}
          deleteError={deleteError}
          menuTarget={menuTarget}
        />
      ) : (
        <p className='no-data-message'>Нет данных для отображения</p>
      )}

      {/* CreateWorkplace с анимацией */}
      {isCreateWorkplaceMounted &&
        createPortal(
          <CreateWorkplace
            selectedTab={selectedTab}
            departmentId={expandedRow}
            isEmployeeFormOpen={isCreateWorkplaceVisible}
            handleClose={handleCloseCreateWorkplace}
            selectedItemId={selectedItemId}
            updateDepartmentData={updateDepartmentData}
          />,
          document.body
        )}

      {showMenu &&
        createPortal(
          <ContextMenu
            top={menuPosition.top}
            left={menuPosition.left}
            onEdit={handleEdit}
            onDuplicate={handleDuplicate}
            onArchive={handleArchive}
            onDelete={handleDelete}
            onClose={handleCloseMenu}
          />,
          document.body
        )}
      <div className='workplaces-tab__wrapper-btn'>
        <ButtonRolesAction
          onClick={handleOpenCreateWorkplace}
          className={'ButtonRolesAction_add'}
        >
          + ДОБАВИТЬ РАБОЧИЕ МЕСТО
        </ButtonRolesAction>
      </div>

      {isPopupMounted &&
        createPortal(
          <InviteEmployee
            isActive={isVisiblePopupInvite}
            isLoading={isLoading}
            onSubmit={handleInviteSubmit}
            onClose={handleClosePopup}
            errorText={error}
            selectedItemId={selectedItemId}
          />,
          document.body
        )}
      {isNotificationVisible &&
        createPortal(
          <NotificationPopup
            message={`Приглашение отправлено пользователю с логином ${loginInvitedUser}`}
            onClose={() => console.log('закрыть')}
          />,
          document.body
        )}
    </div>
  );
};

export default WorkplacesTab;
